import AbstractEditWidget from "./AbstractEditWidget";
import { Checkbox } from "../../../lib/ui/controls/Checkbox";
import { C } from "../../../lib/ui/constructors";
import TextField from "../../../lib/ui/controls/TextField";
var vbox = C.vbox;
var hbox = C.hbox;
import { FakeLodash } from "../../../lib/coreutil/FakeLodash";
export class EntityNameEdit extends AbstractEditWidget {
    constructor(kinds = ["npc", "static"]) {
        super(vbox().container);
        this.kinds = kinds;
    }
    render() {
        this.empty();
        const specifics_container = hbox();
        let group = undefined;
        if (this.kinds.length > 1) {
            const buttons = this.kinds.map(kind => {
                const name = {
                    "npc": "NPC",
                    "static": "Object",
                    "item": "Item"
                }[kind];
                return { value: kind, button: new Checkbox(name, "radio") };
            });
            const group = new Checkbox.Group(buttons, false)
                .setValue(this.get()?.kind || "static")
                .onChange(v => {
                const copy = FakeLodash.cloneDeep(this.get());
                if (copy) {
                    copy.kind = v;
                    this.commit(copy);
                }
            });
            specifics_container.append(...group.buttons.map(b => b.button));
        }
        const name = new TextField()
            .css("width", "100%")
            .setValue(this.get()?.name || "")
            .onCommit(v => {
            if (!v)
                this.commit(null);
            else {
                let copy = FakeLodash.cloneDeep(this.get());
                if (!copy) {
                    copy = { name: "", kind: group?.get() ?? copy.kind };
                }
                copy.name = v;
                this.commit(copy);
            }
        });
        this.append(name, specifics_container);
    }
}
